export enum ContactType {
  Phone,
  Email,
  Fax,
  Address,
  Website,
}
